import { MemberLevelState } from "./memberLevel.types";

export const state: MemberLevelState = {
  memberLevels: [],
  memberLevel: null,
  loading: false,
  error: false,
  pagination: null
};
